const setState = (state = {}) => {
    const url = new URL(window.location);
    const params = new URLSearchParams(url.search);

    for (let key in state) {
        if (state.hasOwnProperty(key)) {
            params.set(key, state[key])
        }
    }
    window.history.pushState({}, '', `?${params.toString()}`);
}

const getFilteredTeamMembers = (teamMembers) => {
    const url = new URL(window.location);
    const params = new URLSearchParams(url.search);
    if (params.get('tag') && '' !== params.get('tag')) {
        return Array.from(teamMembers).filter(member => member.classList.contains(params.get('tag')));
    } else {
        return teamMembers;
    }
}

const showAllTeamMembers = (teamMembers, pageSize) => {
    // hide all (also the ones display before)
    for (let i = 0; i < teamMembers.length; i++) {
        teamMembers[i].style.display = 'none';
    }
    // display only until pageSize
    for (let i = 0; i < teamMembers.length; i++) {
        if (i < pageSize) {
            teamMembers[i].style.display = '';
        }
    }
}

// Case tag with on click deactivated
document.querySelectorAll('form.tag-filter input').forEach( element => {
    const team = document.querySelector('.team');
    const teamMembers = team.querySelectorAll('.team-member-card');
    const allTopicsFilter = document.querySelector('#all-topics-filter');
    const pagination = team.querySelector('scale-pagination');
    const pageSize = pagination ? pagination.getAttribute('page-size') : team.querySelector('.team-member-card-collection').dataset.teamcount;

    element.addEventListener('click', evt => {
        // deselect tag if a filter was active
        if (element.value === team.dataset.tagchoosen) {
            team.dataset.tagchoosen = '';
            allTopicsFilter.checked = true;
            showAllTeamMembers(team.querySelectorAll('.team-member-card'), pageSize);
            setState({
                p: 1,
                tag: ''
            });
            if (pagination) {
                pagination.startElement = 0;
                pagination.pageSize = pageSize;
                pagination.totalElements = teamMembers.length;
            }
        } else {
            team.dataset.tagchoosen = element.value;
        }
    })
});

document.querySelectorAll('.team').forEach(team => {

    const pagination = team.querySelector('scale-pagination');
    const pageSize = pagination ? Math.abs(pagination.getAttribute('page-size')) : team.querySelector('.team-member-card-collection').dataset.teamcount;

    const teamMembers = team.querySelectorAll('.team-member-card');
    const page = Math.abs((new URL(window.location)).searchParams.get('p') ?? '1');

    const initalStartElement = Math.abs(page-1) * pageSize;

    team.querySelector('form').addEventListener('change', evt => {

        const filteredTeamMembers = Array.from(teamMembers).filter(
            member => member.classList.contains(evt.target.value)
        )

        if (pagination) {
            pagination.startElement = 0;
        }

        // case "All Roles"
        if ('' === evt.target.value) {
            setState({
                p: 1,
                tag: evt.target.value
            });

            showAllTeamMembers(teamMembers, pageSize);

            if (pagination) {
                pagination.totalElements = teamMembers.length;
            }

        // case "Role identifier" given
        } else {
            if (pagination) {
                pagination.totalElements = filteredTeamMembers.length;
            }

            Array.from(teamMembers).filter(member => !member.classList.contains(evt.target.value)).forEach(member => {
                member.style.display = 'none';
            });
            filteredTeamMembers.forEach((card, index) => {
                if (index >= 0 && index < (pageSize)) {
                    card.style.display = '';
                } else {
                    card.style.display = 'none';
                }
            });
            setState({
                p: 1,
                tag: evt.target.value
            });
        }
    });

    if (pagination) {
        // hide page > 1
        teamMembers.forEach((card, index) => {
            if (index >= initalStartElement && index < (initalStartElement + pageSize)) {
                card.style.display = '';
            } else {
                card.style.display = 'none';
            }
        });

        pagination.addEventListener('scale-pagination', evt => {
            const startElement = evt.detail.startElement;

            let visibleCount = 0;

            getFilteredTeamMembers(teamMembers).forEach((card, index) => {
                if (index >= startElement && index < (startElement + pageSize)) {
                    card.style.display = '';
                    visibleCount++;
                } else {
                    card.style.display = 'none';
                }
            });

            setState({
                p: (evt.detail.startElement / pageSize)+1
            });
            team.scrollIntoView();
        });
    }

    team.querySelector('form input:checked').dispatchEvent(new Event('change', { bubbles: true }));
});
